module.exports = __webpack_public_path__ + "static/intro-lovesong-b3e7138f5a64418f8d69318dc43f35a6.mp4";